'use client';

import Sidebar from '@/components/Sidebar';
import isEmpty from 'lodash/isEmpty';
import { useTranslations } from 'next-intl';
import VanBanPage from '@/page/VanBanPage/VanBanPage';
import ChuyenMucPage from '@/page/ChuyenMucPage/ChuyenMucPage';
import KienNghiCuTriPage from '@/page/KienNghiCuTriPage/KienNghiCuTriPage';
import DonThuPage from '@/page/DonThuPage/DonThuPage';
import PdfPage from '@/page/PdfPage/PdfPage';
import LichPage from '@/page/LichPage/LichPage';
import DuThaoPage from '@/page/DuThaoPage/DuThaoPage';
import TinTongHopPage from '@/page/TinTongHopPage/TinTongHopPage';
import ChiTietBaiVietPage from '@/page/ChiTietBaiVietPage/ChiTietBaiVietPage';

export default function TinTucDetailPage(props) {
  const { menuActive, posts, rightBanners, linkPages, websiteCode } = props;

  const t = useTranslations('');

  if (!menuActive && !posts) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[500px] text-center px-4">
        <div className="relative">
          <div
            className="absolute -top-10 -left-10 w-20 h-20 bg-gradient-to-br 
                        from-red-100 to-pink-100 rounded-full opacity-60 animate-pulse"></div>
          <div
            className="absolute -bottom-10 -right-10 w-16 h-16 bg-gradient-to-br 
                        from-purple-100 to-blue-100 rounded-full opacity-60 animate-pulse delay-500"></div>
          <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-100 p-8 max-w-md mx-auto">
            <div className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-pink-500 mb-4">404</div>
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-red-400 to-pink-500 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 
                                        012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <p className="text-2xl font-bold text-gray-800 mb-3">{t('home.erorrNotFound')}</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => window.history.back()}
                className="px-6 py-3 bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 
                                    hover:to-pink-700 text-white rounded-lg font-medium transition-all duration-200 
                                    transform hover:scale-105 shadow-lg hover:shadow-xl cursor-pointer">
                ← {t('home.back')}
              </button>
              <button
                onClick={() => (window.location.href = '/')}
                className="px-6 py-3 bg-white border-2 border-gray-200 hover:border-gray-300 
                                    text-gray-700 hover:text-gray-900 rounded-lg font-medium transition-all 
                                    duration-200 transform hover:scale-105 hover:shadow-md cursor-pointer">
                🏠 {t('home.hometitle')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (menuActive?.type === 'table') {
    return <VanBanPage {...props} />;
  } else if (menuActive?.type === 'collection') {
    return <ChuyenMucPage {...props} />;
  } else if (menuActive?.type === 'ykct') {
    return <KienNghiCuTriPage {...props} />;
  } else if (menuActive?.type === 'qldt') {
    return <DonThuPage {...props} />;
  } else if (menuActive?.type === 'pdf') {
    return <PdfPage {...props} />;
  } else if (menuActive?.type === 'schedule') {
    return (
      <div className="px-2 md:px-4 pt-2 bg-white shadow-sm py-2 container mx-auto">
        <LichPage {...props} />{' '}
      </div>
    );
  } else if (menuActive?.type === 'advice') {
    return <DuThaoPage {...props} />;
  } else if (menuActive?.type === 'postsRss') {
    return <TinTongHopPage {...props} />;
  } else {
    if (isEmpty(posts)) {
      return (
        <div className="flex flex-col min-h-screen">
          <div className=" container mx-auto px-2 md:px-4 pt-2  bg-white shadow-sm py-2">
            <div className="flex flex-col lg:flex-row gap-6">
              <main className="lg:w-3/4 ">
                <div className="container mx-auto  text-left text-gray-500 text-base">{t('news.updateNew')}</div>
              </main>
              <div className="w-full md:w-1/4 ">
                <Sidebar rightBanners={rightBanners} linkPages={linkPages} websiteCode={websiteCode} />
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <ChiTietBaiVietPage {...props} />;
    }
  }
}
